<template>
  <div class="pager">
    <a :rel="createFollow('prev')" :href="prevUrl()" remote="true" :class="{ 'hide': page === 1 }" >Prev</a>
    <a :rel="createFollow('')" :class="{'active': $props.page === parseInt(pages) }" :href="url + '?page=' + pages" v-for="pages in pageArray">{{ pages }}</a>
    <a :rel="createFollow('next')" :href="nextUrl()" remote="true" :class="{ 'hide': page === pageCount }" >Next</a>
  </div>
</template>

<script>
    // this is an a-link pager
    export default {
        data: function () {
            return {
                pageArray: [],
                url: window.location.href.split("?")[0]
            }
        },
        props: {
            pageCount: Number,
            page: Number,
            nofollow: Boolean
        },
        watch: {
            "pageCount": function(oldV, newV) {
                this.calcPages();
            }
        },
        methods: {
            prevUrl() {
                let prev = this.$props.page - 1;
                if (this.$props.page !== 1) {
                    return this.url + "?page=" + prev;
                }
            },
            nextUrl() {
                let next = this.$props.page + 1;
                if (this.$props.page !== this.$props.pageCount) {
                    return this.url + "?page=" + next;
                }
            },

            createFollow(name) {
                let follow = this.$props.nofollow ? 'nofollow' : '';
                return name.concat(' ', follow);
            },

            calcPages() {
                const app = this,
                      potential = document.body.clientWidth < 800 ? 7 : 15;
                let start = 1,
                    range = app.$props.pageCount <= potential ? app.$props.pageCount : potential,
                    pages = app.$props.pageCount,
                    current = app.$props.page,
                    paging = [],
                    end;

                let i = Math.min(pages + start - range, Math.max(start, current - (range / 2 | 0)));
                end = i + range;
                while (i < end) {
                    paging.push(`${i++}`)
                }
                app.pageArray = paging;
            }
        }
    }
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.pager {
    margin: 1.25rem 0 1.25rem;
    display: flex;
    justify-content: center;
    max-width: 100%;
    flex-wrap: wrap;
}

a {
    text-align: center;
    color: #4a4a4a;
    font-weight: 600;
    background: $col_white;
    display: inline-block;
    outline: 0;
    padding: 0.625rem;
    cursor: pointer;
    font-size: .875rem;
    height: 2.5rem;
    line-height: 1.25rem;
    margin: 0 .625rem .625rem 0;
    border-radius: .25rem;
    box-sizing: border-box;
    box-shadow: 0 .125rem 0.188rem 0 rgba(0, 0, 0, 0.4);
    text-decoration: none;
    background-color: $col_white;

    &[rel="prev"],
    &[rel="next"] {
        width: 6.25rem;
        border: 0.063rem solid #4a4a4a;
    }

  &.active {
    background: $col_primary;
    color: $col_white;
  }

  &.hide {
    display: none;
  }
}

@media #{$desktop} {
    .pager {
      margin: 0 0 1.25rem;
      justify-content: flex-end;
    }
}

</style>